import React from "react";

const ResetFilterButton = ({ visible, onClick }) => {
  if (!visible) return null;

  return (
    <button
      type="button"
      className="button rounded-button button-reset-filter"
      aria-label="Reset filter"
      onClick={onClick}
    >
      <span className="material-icons-round" aria-hidden="true">
        filter_alt_off
      </span>
      Reset Filter
    </button>
  );
};

export default ResetFilterButton;
